import type { ReactNode } from 'react';
import {
  ClipboardDocumentListIcon,
  EnvelopeIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';
import { WorkspaceSectionCard } from '../../../../components/workspaces/EntityWorkspacePrimitives';

const TAB_PRESENTATION = {
  'Custom Input Fields': {
    title: 'Custom Input Fields',
    description: 'Collect additional information from supporters during checkout.',
    icon: ClipboardDocumentListIcon,
  },
  FAQs: {
    title: 'FAQs',
    description: 'Answer common supporter questions on the form and hosted page.',
    icon: QuestionMarkCircleIcon,
  },
  Emails: {
    title: 'Emails',
    description: 'Customize the confirmation email sent after a completed submission.',
    icon: EnvelopeIcon,
  },
} as const;

type FormWorkspaceTabSectionProps = {
  tabName: keyof typeof TAB_PRESENTATION;
  enabled?: boolean;
  children: ReactNode;
};

export function FormWorkspaceTabSection({
  tabName,
  enabled = true,
  children,
}: FormWorkspaceTabSectionProps) {

  if (!enabled) {
    return (
      <div className="scroll-mt-4">
        {children}
      </div>
    );
  }

  const presentation = TAB_PRESENTATION[tabName];

  return (
    <div className="scroll-mt-4">
      <WorkspaceSectionCard
        title={presentation.title}
        description={presentation.description}
        icon={presentation.icon}
      >
        {children}
      </WorkspaceSectionCard>
    </div>
  );
}
